import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';

import * as Colors from 'material-ui/styles/colors';
import { avatar as avatarColours } from '../../constants/ColourConstants';

import BasicProgressBar from '../ProgressBar/BasicProgressBar';


const style = {
    listItem: {
        padding: '2px',
    }
};

const CourseEnrolmentStatsUserListItem = ({data}) => {

    const infoLink = `/dashboard/courses/enrolments/user/${data.userId}`;
    const initial = data.fullName.charAt(0).toUpperCase();
    const description = `${data.completed} / ${data.total} ${data.waiting ? `(${data.waiting} waiting)` : ''}`;

    const listItemProps = {
        key: data.userId,
        primaryText: <Link to={infoLink} className="primaryText">{data.fullName}</Link>,
        secondaryText: (
            <div className="secondaryInfo">
                <BasicProgressBar
                    total={data.total}
                    completed={data.completed}
                    success={!data.waiting && !data.enrolled}
                    link={infoLink}
                />
                <em><Link to={infoLink}>{description}</Link></em>
            </div>
        ),
        secondaryTextLines: 2
    };

    const avatarStyle = (data.waiting || data.enrolled) ? avatarColours.courseDefault : avatarColours.courseCompleted;

    return (
        <ListItem {...listItemProps}
            leftAvatar={
                <Link to={infoLink}>
                    <Avatar color={Colors.white} style={avatarStyle}>
                        {initial}
                    </Avatar>
                </Link>
            }
        />
    )
};

CourseEnrolmentStatsUserListItem.propTypes = {
    data: PropTypes.shape({
        userId: PropTypes.number.isRequired,
        fullName: PropTypes.string.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string,

        waiting: PropTypes.number,
        enrolled: PropTypes.number,
        completed: PropTypes.number,
        total: PropTypes.number
    })
};

export default CourseEnrolmentStatsUserListItem;
